<template>
  <div>
    <a-menu mode="vertical" :default-selected-keys="defaultSelectd" @click="handleClick" class="teacher-menu">
      <a-menu-item key="data">
        <router-link to="report">
          <a-icon type="bar-chart" />
          教学数据
        </router-link>
      </a-menu-item>
      <a-menu-item key="course">
        <router-link to="course">
          <a-icon type="book" />
          授课中心
        </router-link>
      </a-menu-item>
      <a-menu-item key="work">
        <!-- <router-link to="work">
          <a-icon type="form" />
          作业批改
        </router-link> -->
        <router-link :to="{path:'workGroup'}">
          <a-icon type="form" />
          作业批改
        </router-link>
      </a-menu-item>
      <a-menu-item key="additionWork">
        <router-link to="additionWork">
          <a-icon type="build" />
          自定义教学
        </router-link>
      </a-menu-item>
      <a-menu-item key="depart">
        <router-link :to="{path:'depart',query: {tab: 1}}">
          <a-icon type="apartment" />
          班级管理
        </router-link>
      </a-menu-item>
      <a-menu-item key="student">
        <router-link to="student">
          <a-icon type="user" />
          学生管理
        </router-link>
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
export default {
  name: "SideMenuTeacher",
  data() {
    return {
      defaultSelectd: []
    };
  },
  created(){
    this.defaultSelectd.push(this.$route.name) 
  },
  methods: {
    handleClick(e) {
      console.log("click ", e);
    },
  },
};
</script>

<style lang="less" scoped>
.teacher-menu {
  text-align: left;
  .ant-menu-item {
    height: 80px;
    line-height: 80px;
    align-items: center;
    font-size: 16px;
    padding-left: 30px;
  }
  .ant-menu-item-selected,.ant-menu-item-active {
    border-left: solid 5px @primary-color;
  }
}
</style>